import React from 'react';
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { callService, goTo } from "../tools";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { servicios } from "../properties";
import axios from 'axios';
import { CropLandscapeOutlined } from '@material-ui/icons';
import firebase from 'firebase';

const portalesReing = "portales/portalReingenieria";
let elemento = '';
const textoLabelCorreoLleno = "textoLabelCorreoLleno";
const textoLabelCorreo = "textoLabelCorreo";
const textoLabelCorreoFocus = "textoLabelCorreoFocus";
const inputEmail = "inputEmail";
const input = "input";
const complete = "complete";
const spanCorreo = "spanCorreo";
const palabraErrorMin = "error";
const palabraErrorMayus = "Error";
var uid_encript = "";
var clave_temp = "";
const modalEnvio = "#modal-envio";
const envioCorreoMsjerror = "Envio de correo electrónico";
const ocurrioErrorMsj = "Ocurrio un error inesperado, intente mas tarde.";
const aplication = 'application/json';
var cveCliente = "";

const mapState = (state) => {
    return {
        paso: state.olvideContrasenia.paso,
        email: state.olvideContrasenia.email,
    };
}

const mapDispatch = (dispatch) => {
    return {
        setPaso: (paso) => {
            dispatch({ "type": "PASO_SIGUIENTE_OLVIDE_CONTRASENIA", "paso": paso });
        },
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        },
        setEmail: (correo) => {
            dispatch({ "type": "SET_EMAIL", "email": correo });
        },
        verificarEmail: (correo, disp) => {
            dispatch({
                "type": "LOGIN_SET_CORREO",
                "correo": correo
            });
            dispatch({
                "type": "RECUPERAR_SET_FLAG_ERROR",
                "flag": false
            });
            dispatch(verificarEmail(correo, disp));
        },
    }
}

const valorV = (val) => {
    if (val === "") {
        document.getElementById(input).innerHTML = "";
        document.getElementById(complete).innerHTML = '';
    }
}

class CorreoOlvideContrasenia extends React.Component {

    state = {
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: "",
        pass: ""
    }



    componentWillMount = () => {

        setTimeout(() => {
            if (this.props.email !== "") {
                document.getElementsByClassName(inputEmail)[0].value = this.props.email;
                document.getElementsByClassName(textoLabelCorreo)[0].className = textoLabelCorreoLleno
            } else {
                console.log('');
            }
        }, 500);
        this.clasesLabel = textoLabelCorreo;
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 300);
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    regresar = () => {
        this.props.setPaso(0);
    }

    siguiente = () => {
        this.props.loader(true);
        const email = document.getElementsByClassName(inputEmail)[0].value.trim();
        console.log("email sin espacios ", email);

        new callService({
            service: 'registro.obtenerNombreMedios',
            "secure": true,
            data: {
                email: email.replace(/ /g, ""),
                banReset: true
            }
        }).execute().then(body => {
            cveCliente = body.cveClienteUnico;

            setTimeout(() => {
                this.generaNodoFirebase();
                this.validarEstadoCorreo(email.replace(/ /g, ""));


            }, 1500);

        }).catch(error => {
            console.log('error', error);
            this.props.loader(false);
            this.muestraTooltip(true, palabraErrorMin,
                envioCorreoMsjerror, ocurrioErrorMsj);
        });

    }

    validarEstadoCorreo = (email) => {
        if (email === "" || email === undefined) {
            this.emailVacio();
        } else if (email !== "" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            this.errorCorreoInc = true;
            this.emailLleno();
        } else if (email !== "" && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            this.emailLlenoCorrecto(email.replace(/ /g, ""));
        } else {
            this.correoContinua = false;
        }
    }

    emailVacio = () => {
        document.getElementsByClassName(spanCorreo)[0].innerHTML = "Campo Obligatorio";
    }

    emailLleno = () => {
        document.getElementsByClassName(spanCorreo)[0].innerHTML = "Formato incorrecto";
    }

    emailLlenoCorrecto = (email) => {
        document.getElementsByClassName(spanCorreo)[0].innerHTML = "";
        this.registroInconcluso(email.replace(/ /g, ""));
    }

    handleFocusCorreoFun = () => {
        const emailCor = document.getElementsByClassName(inputEmail)[0].value;
        if (emailCor === "" || emailCor === undefined) {
            elemento = document.getElementsByClassName(textoLabelCorreo)[0];
            elemento.className = textoLabelCorreoFocus;
            if (elemento !== '') {
                console.log('listoValidacion');
            } else {
                elemento = document.getElementsByClassName(textoLabelCorreoLleno)[0];
                elemento.className = textoLabelCorreo;
            }
        } else {
            console.log('listo');
        }
    }

    correoLleno = () => {
        if (document.getElementById(input).value !== "") {
            const elementoLabel = document.getElementsByClassName(textoLabelCorreo);
            elementoLabel.className = textoLabelCorreoLleno;
        }
    }

    handleBlurEmail = (e) => {
        let elementoEmail = "";
        let elemento2 = "";
        const valor = e.target.value;

        if (valor === "") {
            elementoEmail = document.getElementsByClassName(textoLabelCorreoFocus)[0];
            elemento2 = document.getElementsByClassName(textoLabelCorreoLleno)[0];
            if (elementoEmail !== undefined) {
                elementoEmail.className = textoLabelCorreo;
            } else {
                elemento2.className = textoLabelCorreo;
            }
            valorV(valor);
        } else {
            document.getElementsByClassName(textoLabelCorreoFocus)[0].className = textoLabelCorreoLleno;
        }
        this.props.setEmail(valor);
    }

    validateEmail = (email) => {
        email = email.toLowerCase();
        const pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return pattern.test(email.replace(/ /g, ""));
    }

    registroInconcluso = (email) => {
        this.props.loader(true);

        new callService({
            "service": "registro.incConsultaRegistro",
            "secure": true,
            "data": {
                "correo": email.toLowerCase()
            }
        }).execute().then((respuesta) => {
            console.log("respuesta ingresaCorreo incConsultaRegistro:", respuesta);

            if (respuesta.banConcluirReg.toString() === 'false') {
                localStorage.setItem("banConcluirReg", respuesta.banConcluirReg);
                localStorage.setItem("correoInconcluso", email);
                localStorage.setItem("correoModal", email);
                goTo("gnp/registro");

                this.props.loader(false);
            } else {
                const newPass = localStorage.getItem("newPass");


                if (newPass === null) {
                    this.props.loader(false);
                    localStorage.removeItem("banConcluirReg");
                    this.validarEmail(email.replace(/ /g, ""));
                } else {
                    console.log("***** recuperar contraseña con clave");
                    axios({
                        method: 'POST',
                        url: servicios.utilerias.actualizaNodoRestablecer,
                        headers: {
                            'Content-Type': aplication,
                            'Access-Control-Allow-Origin': '*',
                            "valor": newPass,
                            "encripta": true
                        }
                    }).then(response => {
                        this.verificarEmail(response.data.hash);
                    }).catch(error => {
                        console.log("errors", error);
                    });
                }


            }
        }).catch((error) => {
            localStorage.removeItem("banConcluirReg");
            this.props.loader(false);
            this.establecer();
            console.log("Error??", error);
        });
    }

    validarEmail = (correo) => {
        this.props.loader(true);
        axios({
            method: 'POST',
            url: servicios.utilerias.actualizaNodoRestablecer,
            headers: {
                'Content-Type': aplication,
                'Access-Control-Allow-Origin': '*',
                "valor": correo,
                "encripta": true
            }
        }).then(response => {
            const encriptar = true;
            new callService({
                "service": "login.bienvenido",
                "secure": true,
                "data": { "correo": response.data.hash, "encriptar": encriptar }
            }).execute().then(body => {

                if (body.consultarClienteResponse.banderaExitoReg || !body.consultarClienteResponse.banderaExitoReg) {
                    this.props.loader(false);
                    this.establecer();
                } else {
                    this.props.loader(false);
                    this.muestraTooltip(true, palabraErrorMin,
                        palabraErrorMayus, "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.");
                }
            }).catch(error => {
                console.log("errorss", error);
                this.props.loader(false);

                if (error.message.codigoError === "eCl00014") {
                    this.muestraTooltip(true, palabraErrorMin,
                        palabraErrorMayus, "El cliente no esta registrado.");
                } else {
                    this.muestraTooltip(true, palabraErrorMin,
                        palabraErrorMayus, "Ocurrio un error inesperado, intente mas tarde.");
                }
            });
        }).catch(error => {
            console.log("errorr", error);
        });
    }

    establecer = () => {
        const tokenFirebase = localStorage.getItem("tokenFirebase");
        this.props.loader(true);
        let origenP = "false";

        firebase.database().ref(portalesReing).once("value").then(oValue => {
            var data = oValue.val();
            origenP = !data ? "true" : "false";
        })


        axios({
            url: servicios.utilerias.actualizaNodoRestablecer,
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': aplication,
                "encripta": true,
                "valor": tokenFirebase,
            }
        }).then(response => {
            const token = response.data.hash;
            new callService({
                "secure": true,
                service: 'olvideContrasena.restablecerPass',
                data: {
                    "correo": this.props.email,
                    "cveTemporal": "",
                    "banAppOlvide": false,
                    "url": "",
                    "origenPortal": origenP,
                    "token": token
                }
            }).execute().then(body => {
                this.props.loader(false);
                $(modalEnvio).modal("toggle");
                localStorage.removeItem("tokenFirebase");
            }).catch(error => {
                console.log("errork", error);
                this.props.loader(false);
                this.muestraErrorOlvide(error);
            });

        }).catch(error => {
            console.log("errore", error);
        });

    }

    generaNodoFirebase = () => {
        let caracteresFinales = '';
        let clave = '';
        let claveFinal = '';

        const caracteres = {
            numeros: '0 1 2 3 4 5 6 7 8 9'
        }

        caracteresFinales += caracteres.numeros;
        caracteresFinales = caracteresFinales.trim();
        caracteresFinales = caracteresFinales.split(' ');

        for (let i = 0; i < 5; i++) {
            clave += caracteresFinales[Math.floor(Math.random() * caracteresFinales.length)];
        }

        claveFinal = cveCliente + clave;
        localStorage.setItem("tokenFirebase", claveFinal);

        new callService({
            service: 'utilerias.tokenRestablecer',
            "secure": true,
            data: { update: true, uid: cveCliente, token: claveFinal }
        }).execute().then(body => {
            console.log("respuesta tokenRestablecer", body);
        }).catch(error => {
            console.log('error', error);
        });
    }

    muestraErrorOlvide = (error) => {
        if (error.inactivo) {
            this.muestraTooltip(true, palabraErrorMin,
                envioCorreoMsjerror, "Usuario no activo.");
        } else {
            this.muestraTooltip(true, palabraErrorMin,
                envioCorreoMsjerror, ocurrioErrorMsj);
        }
    }

    verificarEmail = (pass) => {
        let origenP = "false";
        this.props.loader(true);
        const tokenFirebase = localStorage.getItem("tokenFirebase");

        firebase.database().ref(portalesReing).once("value").then(oValue => {
            var data = oValue.val();
            if (!data) {
                origenP = "true";
            }
        })

        axios({
            method: 'POST',
            url: servicios.utilerias.actualizaNodoRestablecer,
            headers: {
                'Content-Type': aplication,
                'Access-Control-Allow-Origin': '*',
                "valor": tokenFirebase,
                "encripta": true
            }
        }).then(response => {
            const token = response.data.hash;

            new callService({
                service: 'olvideContrasena.restablecerPass',
                "secure": true,
                data: {
                    "correo": this.props.email,
                    "cveTemporal": localStorage.getItem("newPass"),
                    "banAppOlvide": false,
                    "url": "",
                    "origenPortal": origenP,
                    "token": token
                }
            }).execute().then(body => {
                if (body.correlationId !== "") {
                    $(modalEnvio).modal("toggle");
                    this.resetPass(pass);
                } else {
                    this.props.loader(false);
                    this.muestraTooltip(true, palabraErrorMin,
                        envioCorreoMsjerror, ocurrioErrorMsj);
                }
            }).catch(error => {
                this.props.loader(false);
                console.log("error olvideContraseña", error);
                this.muestraErrorOlvide(error);
            });

        }).catch(error => {
            console.log("errora", error);
        });

    }

    resetPass = (pass) => {
        setTimeout(() => {
            this.reseteandoPassword(pass);
        }, 1000);
    }

    reseteandoPassword = (pass) => {
        axios({
            method: 'POST',
            url: servicios.utilerias.actualizaNodoRestablecer,
            headers: {
                'Content-Type': aplication,
                'Access-Control-Allow-Origin': '*',
                "valor": cveCliente,
                "encripta": true
            }
        }).then(response => {
            uid_encript = response.data.hash;
            axios({
                method: 'POST',
                url: servicios.utilerias.actualizaNodoRestablecer,
                headers: {
                    'Content-Type': aplication,
                    'Access-Control-Allow-Origin': '*',
                    "valor": localStorage.getItem("tokenFirebase"),
                    "encripta": true
                }
            }).then(resp => {
                clave_temp = resp.data.hash;
                new callService({
                    service: 'olvideContrasena.actualizarPassword',
                    "secure": true,
                    data: {
                        "uid": uid_encript,
                        "pass": pass,
                        "token": clave_temp,
                        "borrarNodo": false
                    }
                }).execute().then(body => {
                    new callService({ service: "login.desbloqueoMedios", secure: true, data: { "uid": uid_encript } }).execute();
                    setTimeout(() => {
                        this.removiendoItem();
                    }, 2000);
                    this.props.loader(false);
                }).catch(error => {
                    this.props.loader(false);
                    console.log("ERROR", error);
                });
            }).catch(error => {
                console.log("error", error);
            });
        }).catch(error => {
            console.log("errorx", error);
        });
    }

    removiendoItem = () => {
        localStorage.removeItem("tokenFirebase");
    }

    ir = (sRuta) => {
        this.props.setPaso(0);
        this.props.setEmail("");
        $(modalEnvio).modal("hide");
        firebase.database().ref(portalesReing).once("value").then(oValue => {
            var data = oValue.val();
            if (!data) {
                goTo(sRuta);
            } else {
                window.location.assign(servicios.dominioReingenieria);
            }
        })
    }

    render() {
        return (
            <div id='formCorreoOlv' style={{ height: "510px", background: "white" }}>
                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                    show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
                </ModalSintillo>

                <div id="correoOlvide" className="txt-center" style={{ background: '#FFFFFF' }}>

                    <div className='div-title-olv'>
                        <span className="material-icons bi bi-arrow-left" style={{ float: "left", cursor: "pointer", marginTop: "20px" }} onClick={this.regresar}>
                            arrow_back
                        </span>
                        <label id="txt-title-olvide">Recuperar contraseña</label>
                        <br />
                        <hr className="label-hr" />
                    </div>
                    <div className='div-titulo-Olvide'>
                        <span className='titulo-Olvide'>Ingresa el correo electrónico con el que registraste tu cuenta en Soy Cliente GNP </span>
                    </div>

                    <div className="div-correo-olv">

                        <div className='div-input-correo'>
                            <div className="input-wrap email-reg " id="email-registro" >
                                <label className={this.clasesLabel}>Correo electrónico</label>
                                <div id="container-olv">
                                    <div id={complete}></div>
                                    <input name="email" type="text" id={input} placeholder=""
                                        onFocus={this.handleFocusCorreoFun.bind(this)}
                                        autoComplete="off" maxLength="50" className={inputEmail}
                                        onBlur={this.handleBlurEmail}
                                    />
                                </div>
                                <span className={spanCorreo}></span>
                            </div>
                        </div>
                        <div className="div-btn-sig-olv">
                            <button id='btn-sig-correo-olv' type="button" onClick={this.siguiente}
                                className="orange-rectangle-olv btn">Continuar</button>
                        </div>
                    </div>
                </div>

                <div className="modal modal-msj fade" id="modal-envio" tabIndex="-1" role="dialog" aria-labelledby="modal-envioLabel"
                    data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-dialog-olv" role="document">
                        <div className="modal-content modal-content-olv-env">
                            <div className="modal-cabecera modal-cabecera-env">
                                <p id="titulo-modal-olvide">Revisa tu correo electrónico</p>
                            </div>
                            <div className="txt-black-olvide-env">
                                <p>
                                    Haz clic en el enlace que te enviamos para restablecer tu contraseña.
                                </p>
                                <p>
                                    Si no ves el correo electrónico en tu bandeja de entrada revisa otras carpetas como spam.

                                </p>
                            </div>
                            <div className="acept-margin aceptar-cancelar-btn-2 mt-20 ">
                                <button type="button" className="btn orange-btn btn-olv-acp" data-dismiss="modal"
                                    onClick={this.ir.bind(this, "login")}>Aceptar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
CorreoOlvideContrasenia = reduxForm({ form: "correoOlvideContrasenia" })(CorreoOlvideContrasenia);
export default connect(mapState, mapDispatch)(CorreoOlvideContrasenia);



// WEBPACK FOOTER //
// ./src/gnp-olvide-contrasenia/correoOlvideContrasenia.frm.js